import { ChatbotConversation } from "app/containers/Chatbot/types";

// Shared label for a saved conversation so Recent Chats and What Bo has
// learned describe it the same way. Returns undefined until the conversation
// has been summarized, so callers can supply their own fallback.
export const getConversationTitle = (
  conversation: ChatbotConversation
): string | undefined =>
  conversation.summary?.title?.trim() ||
  conversation.summary?.summary?.trim() ||
  undefined;
